<div class="d-flex flex-column min-vh-100">
    <app-navbar></app-navbar>
    <main class="flex-grow-1 container">
        <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
</div>